function redirectToSelectedMonth() {
    const select = document.querySelector('.js-mobile-month-list');
    if (!select) {
        return;
    }

    select.addEventListener('change', event => {
        if (event.currentTarget.value) {
            window.location.href = event.currentTarget.value;
        }
    });
}

redirectToSelectedMonth();